export const BenefitsSection = () => {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-[#333333] mb-8 italic text-center">
            Why Homeowners Love Our RED-E-BINS Residential Dumpster
          </h2>

          <div className="grid md:grid-cols-2 gap-8">
            {/* Left Column - Image */}
            <div className="flex flex-col items-center">
              <img
                src="/redebins/images/house-with-dumpster.jpg"
                alt="RED-E-BIN dumpster in front of a house"
                className="w-full h-64 object-cover rounded-lg mb-4"
              />
              <p className="text-[#333333] text-lg italic">Not too little. Not too big. Just right.</p>
            </div>

            {/* Right Column - Benefits */}
            <div>
              <h3 className="text-2xl md:text-3xl font-bold text-[#333333] mb-6">
                We Are <em className="text-[#E31837]">The Best</em> In The Binz
              </h3>
              <ul className="space-y-4 text-[#333333]">
                <li>
                  <strong>Better customer service & less hassle</strong> than dealing with your regular trash service and too-small trash bin.
                </li>
                <li>
                  <strong>Compact design and small footprint</strong> is easy on landscaping or driveways and fits in tight spaces like alleyways.
                </li>
                <li>
                  <strong>Easy online ordering, on-demand delivery, flexible pick-options, and the lowest prices!</strong>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

